jQuery(document).ready(function($) {
    const ajaxUrl = '/wp-admin/admin-ajax.php'; // URL estándar de WP AJAX

    // Acción al pulsar categoría
    $('#filtros-noticias button').on('click', function() {
        $('#filtros-noticias button').removeClass('active');
        $(this).addClass('active');

        const cat = $(this).data('category');
        const btnCargarMas = $('#cargar-mas-noticias');

        btnCargarMas.data('category', cat).data('page', 1).show();

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: { action: 'filtrar_noticias', category: cat, page: 1 },
            success: function(res) {
                if(res.success) {
                    $('#contenedor-noticias-ajax').html(res.data);
                }
            }
        });
    });

    // Acción al pulsar Cargar Más
    $('#cargar-mas-noticias').on('click', function() {
        const btn = $(this);
        const cat = btn.data('category');
        const nextPage = btn.data('page') + 1;

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: { action: 'filtrar_noticias', category: cat, page: nextPage },
            beforeSend: function() { btn.text('CARGANDO...'); },
            success: function(res) {
                if(res.success) {
                    $('#contenedor-noticias-ajax').append(res.data);
                    btn.data('page', nextPage).text('VER MÁS NOTICIAS');
                } else {
                    btn.hide(); // No hay más posts, escondemos el botón
                }
            }
        });
    });
});